import axios from 'Axios';

export default {
  updateCompany(companyId, data) {
    return axios.put('/admin/company/' + companyId, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },
};
